import Section from "../shared/Section";
import styles from "./Footer.module.css";

const Footer = () => (
  <Section>
    <p className={styles.text}>See you soon!</p>
  </Section>
);

export default Footer;
